"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrentContentProvider = exports.CurrentContentContext = void 0;
const tslib_1 = require("tslib");
const client_core_1 = require("@sensenet/client-core");
const client_utils_1 = require("@sensenet/client-utils");
const react_1 = tslib_1.__importStar(require("react"));
const semaphore_async_await_1 = tslib_1.__importDefault(require("semaphore-async-await"));
const hooks_1 = require("../hooks");
/**
 * Returns a given content as current content
 */
exports.CurrentContentContext = react_1.default.createContext(client_core_1.ConstantContent.PORTAL_ROOT);
exports.CurrentContentContext.displayName = 'CurrentContentContext';
/**
 * Provider component for the CurrentContentContext component.
 * Loads a content from the Repository with the given Id or Path.
 * Has to be wrapped with a **RepositoryContext**
 */
const CurrentContentProvider = (props) => {
    const [loadLock] = react_1.useState(new semaphore_async_await_1.default(1));
    const [content, setContent] = react_1.useState(client_core_1.ConstantContent.EMPTY_CONTENT);
    const [errorState, setErrorState] = react_1.useState();
    const [reloadToken, setReloadToken] = react_1.useState(1);
    const reload = () => setReloadToken(Math.random());
    const repo = hooks_1.useRepository();
    const events = hooks_1.useRepositoryEvents();
    const onDeleteContent = react_1.useCallback((deleted) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        if (deleted.some((deletedContent) => client_utils_1.PathHelper.isInSubTree(content.Path, deletedContent.Path))) {
            const parentContent = yield repo.load({ idOrPath: client_utils_1.PathHelper.getParentPath(deleted[0].Path) });
            setContent(parentContent.d);
        }
    }), [repo, content]);
    react_1.useEffect(() => {
        const subscriptions = [
            events.onContentModified.subscribe((c) => {
                if (c.content.Id === content.Id) {
                    reload();
                }
            }),
            events.onContentDeleted.subscribe((c) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
                onDeleteContent(c.contentData);
            })),
        ];
        return () => subscriptions.forEach((s) => s.dispose());
    }, [content.Id, onDeleteContent, events.onContentDeleted, events.onContentModified, repo]);
    react_1.useEffect(() => {
        const ac = new AbortController();
        if (props.idOrPath) {
            ;
            (() => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
                var _a;
                try {
                    const response = yield repo.load({
                        idOrPath: props.idOrPath,
                        requestInit: { signal: ac.signal },
                        oDataOptions: props.oDataOptions,
                    });
                    setContent(response.d);
                    props.onContentLoaded && props.onContentLoaded(response.d);
                }
                catch (error) {
                    if (!ac.signal.aborted) {
                        setErrorState({
                            currentPath: props.idOrPath,
                            status: (_a = error.response) === null || _a === void 0 ? void 0 : _a.status,
                            error,
                        });
                    }
                }
                finally {
                    loadLock.release();
                }
            }))();
        }
        return () => ac.abort();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [repo, props.idOrPath, reloadToken, loadLock]);
    if (errorState === null || errorState === void 0 ? void 0 : errorState.error) {
        if ((errorState === null || errorState === void 0 ? void 0 : errorState.status) === 404) {
            throw errorState;
        }
        throw errorState.error;
    }
    return (react_1.default.createElement(exports.CurrentContentContext.Provider, { value: content }, props.children));
};
exports.CurrentContentProvider = CurrentContentProvider;
//# sourceMappingURL=current-content.js.map